/* eslint-disable no-debugger */
import { useState, } from 'react';

import OrgUnitData from './OrgUnitData';

const useOrgUnitData = () => {
  const [orgUnitState, setOrgUnitState] = useState(OrgUnitData.INITIAL_STATE);

  const getOrgUnitByOrgUnitId = (orgUnitId) => {
    return OrgUnitData.getOrgUnitByOrgUnitIdData(orgUnitId, orgUnitState, setOrgUnitState);
  };

  return {
    orgUnitState,
    getOrgUnitByOrgUnitId
  };  
};
export default useOrgUnitData;